"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getClientTimeZone = () => {
    try {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    catch (e) {
        return null;
    }
};
exports.default = getClientTimeZone;
